import { useTranslation } from 'react-i18next';

import { BillingInterval } from '@this+that/models';

import { useBillingCurrency } from '../../../../hooks/Billing/useBillingCurrency';
import { useTeamBilling } from '../../../../hooks/Billing/useTeamBilling';
import { formatBillingAmount } from '../../../../utils/billing/billingFormatters';
import { pickPriceAmount } from '../../../../utils/billing/resolveBillingCurrency';

export interface TrialBannerUrgentPriceProps {
  teamId: string;
}

// Kept out of TrialBanner.tsx so the billing-price query only ever fires for
// the URGENT stage, never for calm/warning/expired.
export function TrialBannerUrgentPrice({
  teamId,
}: Readonly<TrialBannerUrgentPriceProps>) {
  const { t, i18n } = useTranslation();
  const { billing, loading } = useTeamBilling(teamId);
  const currency = useBillingCurrency();

  const monthlyPrice = billing?.prices.find(
    (price) => price.interval === BillingInterval.MONTH,
  );

  if (loading || !monthlyPrice) {
    return <>{t('billing.trialBanner.urgent.subtitle')}</>;
  }

  const resolvedAmount = pickPriceAmount(monthlyPrice, currency);

  return (
    <>
      {t('billing.trialBanner.urgent.subtitleWithPrice', {
        price: formatBillingAmount(
          resolvedAmount.unitAmount,
          resolvedAmount.currency,
          i18n.language,
        ),
      })}
    </>
  );
}
